module.exports = __webpack_public_path__ + "img/shoufei_bg.cab3a673.png";